import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className='lg:pt-[168px] pt-[140px] lg:pb-[120px] pb-12 lg:px-20 md:px-10 px-4'>
      <div className='w-full max-w-[845px]'>
        <p className='lg:text-[48px] text-[32px] font-bold text-l-primary'>
          Privacy Policy
        </p>
        <p className='text-base text-l-primary lg:mt-10 mt-6 font-semibold'>
          Legal Avenue is committed to protecting your privacy and takes great
          measures to keep your information safe. This Privacy Policy explains
          how we collect and protect your data. If you have any questions or
          concerns about your data, feel free to contact us at
          info@legalavenue.pk.
        </p>
        <p className='text-base text-l-primary mt-5'>
          This Privacy Policy explains how we collect, use, share, disclose, and
          protect Personal Information about the users of our services,
          including the Lawyers, End-Users, and visitors of the Mobile
          Application (referred to as “You” or “Your” or “Users” in this Privacy
          Policy).
        </p>
        <p className='text-base text-l-primary mt-5'>
          This Privacy Policy demonstrates our commitment to protecting your
          privacy and personal information. Legal Avenue (“We” or “Us” or “Our”)
          prioritizes your privacy and understands any concerns you may have
          regarding the use of Personal Information we collect from you and
          about you. In addition to this Privacy Policy, we have certain
          internal processes and rules to keep your Personal Information private
          and ensure that your information is only used in compliance with this
          Privacy Policy. We have a dedicated privacy staff to implement
          advanced privacy principles and to assure that your data is correctly
          managed and protected
        </p>
        <p className='text-base text-l-primary mt-5'>
          Your use of and access to our Services is subject to this Privacy
          Policy. We respect the privacy rights of our customers, users, and
          other users of our website (LegalAvenue.com) and related websites,
          services, mobile applications provided by Legal Avenue. 
        </p>
        <p className='text-base text-l-primary mt-5'>
          By using our Services, or sharing your information otherwise, you
          accept the terms of this Privacy Policy and agree to be bound by this
          Privacy Policy. You hereby agree to our Services, Use, Sharing, and
          Disclosure of your Personal Information as described in this Privacy
          Policy. Legal Avenue reserves the right to change, modify, add, or
          delete portions of the terms of this Privacy Policy, at our sole
          discretion, at any time. If you do not agree with this Privacy Policy
          at any time, please do not use our Services or give us any information
          otherwise. If you use our Services on behalf of another Person (such
          as your child and spouse), or another Entity (such as your employer),
          you represent that you are authorized by that Person or Entity to (1)
          Accept this Privacy Policy on the Person’s or Entity’s behalf and (2)
          Agree on behalf of such Person or Entity to our Services and Use,
          Sharing, and Disclosure of their Personal Information as described in
          this Privacy Policy
        </p>
        <p className='text-[32px] text-l-primary font-semibold mt-8'>
          Information We Collect from Customers
        </p>
        <p className='text-base text-l-primary mt-4'>
          When you use our Services, we may collect following information:
        </p>
        <p className='text-base text-l-primary mt-5 relative before:content-[""] before:size-1 before:rounded-full before:absolute  before:left-0 before:top-[50%] before:bg-l-primary before:translate-y-[-50%] pl-3'>
          Name: To identify the lawyer
        </p>
        <p className='text-base text-l-primary relative before:content-[""] before:size-1 before:rounded-full before:absolute  before:left-0 before:top-[50%] before:bg-l-primary before:translate-y-[-50%] pl-3'>
          Email: To communicate with lawyers and verify their accounts
        </p>
        <p className='text-base text-l-primary relative before:content-[""] before:size-1 before:rounded-full before:absolute  before:left-0 before:top-[50%] before:bg-l-primary before:translate-y-[-50%] pl-3'>
          Phone Number: For communication and potential account recoveries
        </p>
        <p className='text-base text-l-primary relative before:content-[""] before:size-1 before:rounded-full before:absolute  before:left-0 before:top-[50%] before:bg-l-primary before:translate-y-[-50%] pl-3'>
          Password: To authenticate lawyers and securing lawyer accounts
        </p>
        <p className='text-base text-l-primary relative before:content-[""] before:size-1 before:rounded-full before:absolute  before:left-0 before:top-[50%] before:bg-l-primary before:translate-y-[-50%] pl-3'>
          CNIC (National ID): For lawyer identification, verification, and legal
          compliance
        </p>
        <p className='text-base text-l-primary relative before:content-[""] before:size-1 before:rounded-full before:absolute  before:left-0 before:top-[50%] before:bg-l-primary before:translate-y-[-50%] pl-3'>
          Lawyer Licenses: For authorization and ensuring legal compliance for
          credentials
        </p>
        <p className='text-base text-l-primary relative before:content-[""] before:size-1 before:rounded-full before:absolute  before:left-0 before:top-[50%] before:bg-l-primary before:translate-y-[-50%] pl-3'>
          Bank Account Details: For facilitating any withdrawals requested by
          the lawyers
        </p>
        <p className='text-[32px] text-l-primary font-semibold mt-8'>
          When Do We Collect Information?
        </p>
        <p className='text-base text-l-primary mt-4'>
          We collect your Personal Information when you visit our website
          (LegalAvenue.com) and use our Services.
        </p>
        <p className='text-[32px] text-l-primary font-semibold mt-8'>
          How We Collect Your Information?
        </p>
        <p className='text-base text-l-primary mt-4'>
          <span className='font-semibold'>Geolocation:</span> Legal Avenue may
          collect information about your residential location.
        </p>
        <p className='text-base text-l-primary mt-4'>
          <span className='font-semibold'>Audio and Visual Information:</span>{' '}
          We may collect your audio and visual information when you register for
          our services  
        </p>
        <p className='text-base text-l-primary mt-4'>
          <span className='font-semibold'>Network Information: </span>Internet
          and Legal Avenue may collect information about the device/s you use to
          access our website and/or application. We may also collect information
          about your browser, search preferences, and how you interact with our
          products and advertisements. 
        </p>
        <p className='text-base text-l-primary mt-4'>
          <span className='font-semibold'>Information:</span>Professional We may
          collect information regarding your professional status, employment
          status, and employment history.
        </p>
        <p className='text-[32px] text-l-primary font-semibold mt-8'>
          How We Use Your Information?
        </p>
        <p className='text-base text-l-primary mt-4'>
          This section of the Privacy Policy explains how we use your
          information and also describes the reason for collecting your
          information. We reserve the right to blend this information with other
          information about you and use it for one or more objectives described
          below. 
        </p>
        <p className='text-base text-l-primary mt-5 relative before:content-[""] before:size-1 before:rounded-full before:absolute  before:left-0 before:top-[50%] before:bg-l-primary before:translate-y-[-50%] pl-3'>
          To provide, maintain, and improve our products and services 
        </p>
        <p className='text-base text-l-primary relative before:content-[""] before:size-1 before:rounded-full before:absolute  before:left-0 before:top-[50%] before:bg-l-primary before:translate-y-[-50%] pl-3'>
          To develop new products, services, features, and functionality
        </p>
        <p className='text-base text-l-primary relative before:content-[""] before:size-1 before:rounded-full before:absolute  before:left-0 before:top-[50%] before:bg-l-primary before:translate-y-[-50%] pl-3'>
          To detect frauds and maintain appropriate internal security controls
        </p>
        <p className='text-base text-l-primary relative before:content-[""] before:size-1 before:rounded-full before:absolute  before:left-0 before:top-[50%] before:bg-l-primary before:translate-y-[-50%] pl-3'>
          To understand how use and interact with our website, products, and
          services
        </p>
        <p className='text-base text-l-primary relative before:content-[""] before:size-1 before:rounded-full before:absolute  before:left-0 before:top-[50%] before:bg-l-primary before:translate-y-[-50%] pl-3'>
          To operate, maintain, and improve our website and personalize your
          experience
        </p>
        <p className='text-base text-l-primary relative before:content-[""] before:size-1 before:rounded-full before:absolute  before:left-0 before:top-[50%] before:bg-l-primary before:translate-y-[-50%] pl-3'>
          To communicate with you regarding your inquiries and for marketing
          purposes 
        </p>
        <p className='text-[32px] text-l-primary font-semibold mt-8'>
          How Do We Secure Personal Information?
        </p>
        <p className='text-base text-l-primary mt-4'>
          Legal Avenue takes a variety of measures to keep your Personal
          Information safe. We regularly scan our website for security
          loopholes, potential threats, and malware to ensure your information
          is kept safely. <br />
          <br /> We store your information behind secure networks and ensure it
          is only accessible by limited persons who have special rights to
          access this information, and are required to keep this information
          confidential. All sensitive data, including but not limited to, credit
          information is encrypted via Secure Socket Layer (SSL) technology. We
          also employ cloud services and leverage cybersecurity best practices
          to ensure your Personal Information is secure.
        </p>
        <p className='text-[32px] text-l-primary font-semibold mt-8'>
          How We Use Cookies and Similar Technologies?
        </p>
        <p className='text-base text-l-primary mt-4'>
          This section of the Privacy Policy explains how Legal Avenue uses
          Cookies, Web Beacons, and other tracking technologies to collect your
          information.
        </p>
        <p className='text-[32px] text-l-primary font-semibold mt-8'>Cookies</p>
        <p className='text-base text-l-primary mt-4'>
          Just like any other website, Legal Avenue may use cookies to store
          information related to the visitor’s or user’s preferences and the
          pages the visitor or user accessed. We may also utilize third-party
          services, including Google Analytics, DoubleClick Campaign Manager,
          and Google Display Network. We use these technologies to learn about
          our users’ preferences, demographics, behaviors, and interests.
        </p>
        <p className='text-[32px] text-l-primary font-semibold mt-8'>
          Web Beacons
        </p>
        <p className='text-base text-l-primary mt-4'>
          Legal Avenue may utilize web beacons and similar tracking technologies
          to track visitor’s movements and any actions taken by them on our
          website. Web beacons are tiny graphics that unobtrusively recognize
          user activity. They help in tracking user’s online activity and how
          often they visit our website. However, these beacons neither identify
          a person’s private information, nor cause any damage to their device.
        </p>
        <p className='text-[32px] text-l-primary font-semibold mt-8'>
          Third-Party Privacy Policy
        </p>
        <p className='text-base text-l-primary mt-4'>
          Legal Avenue’s Privacy Policy does not apply to third-party
          advertisers, websites, or other assets. We do not have access to or
          control over the tracking technologies used by third-parties,
          including cookies and web beacons. Therefore, we advise you to review
          the privacy policies of these third-parties for more detailed
          information. 
        </p>
        <p className='text-base text-l-primary mt-4'>
          <span className='font-semibold'>Note:</span> If you want to disable
          cookies, you can do that in your individual browser settings. To know
          more about cookie management in specific web browsers, please visit
          the respective browser’s privacy and security policy. 
        </p>
        <p className='text-[32px] text-l-primary font-semibold mt-8'>
          CCPA Privacy Rights
        </p>
        <p className='text-base text-l-primary mt-4'>
          According to CCPA Privacy Rights, California consumers have the rights
          to:
        </p>
        <p className='text-base text-l-primary mt-4'>
          Request that a business that collects their personal information
          clearly discloses and categorizes specific pieces of information
          collected about consumers
        </p>
        <p className='text-base text-l-primary mt-4'>
          Request the business to delete any personal information that the
          business has collected about consumers
        </p>
        <p className='text-base text-l-primary mt-4'>
          Request to opt out of the sale to or sharing of your personal
          information with third parties
        </p>
        <p className='text-base text-l-primary mt-4'>
          <span className='font-semibold'>Note:</span> Legal Avenue does not
          sell, trade, or share your Personal Information with any parties that
          are not mentioned in this Privacy Policy
        </p>
        <p className='text-base text-l-primary mt-4'>
          This does not include our website hosting partners and other parties
          who assist us in operating our website, application, and providing
          Services to our users. These parties are required by law to keep your
          information secure and confidential.
        </p>
        <p className='text-[32px] text-l-primary font-semibold mt-8'>
          GDPR Privacy Rights
        </p>
        <p className='text-base text-l-primary mt-4'>
          This section of the Privacy Policy enlists and explains your data
          protection rights. Under GDPR rights, you have the following rights
        </p>
        <p className='text-base text-l-primary mt-4'>
          <span className='font-semibold'>The right to access:</span> You have
          the right to request copies of your personal data.
        </p>
        <p className='text-base text-l-primary mt-4'>
          <span className='font-semibold'>The right to rectification:</span> You
          have the right to request any corrections made to your information
          that is inaccurate and complete any information you consider
          incomplete.
        </p>
        <p className='text-base text-l-primary mt-4'>
          <span className='font-semibold'>The right to erasure:</span> You have
          the right to request that we erase any data under certain conditions.
        </p>
        <p className='text-base text-l-primary mt-4'>
          <span className='font-semibold'>
            The right to restrict processing:
          </span>
          You have the right to object to processing of your personal data under
          certain conditions
        </p>
        <p className='text-base text-l-primary mt-4'>
          <span className='font-semibold'>The right to data portability:</span>
          You have the right to object to processing of your personal data under
          certain conditions
        </p>
        <p className='text-[32px] text-l-primary font-semibold mt-8'>
          Disclaimer
        </p>
        <p className='text-base text-l-primary mt-4'>
          While we strive to protect your information with industry-standard
          security measures, no online service can guarantee complete security.
          We cannot be held responsible for any unauthorized access or loss of
          data that occurs beyond our reasonable control.
        </p>
        <p className='text-base text-l-primary mt-4'>
          THEREFORE, WE DISCLAIM ANY LIABILITY OF ANY UNAUTHORIZED ACCESS OR
          DAMAGE TO YOUR DATA OR COMMUNICATIONS WITH US. WE ALSO DISCLAIM ANY
          LIABILITY OF THEFT, LOSS, OR INTERCEPTION OF YOUR DATA WHEN YOU USE
          OUR WEBSITE, MOBILE APPLICATION, OR ANY OF SERVICES. BY AGREEING TO
          THIS PRIVACY POLICY, YOU ACKNOWLEDGE THAT YOU ARE AWARE OF THE RISKS
          ASSOCIATED WITH SHARING YOUR DATA ONLINE.
        </p>
        <p className='text-base text-l-primary mt-4'>
          If you want to report any privacy breaches or intend to practice your
          privacy rights, please feel free to contact us at
          (info@legalavenue.pk). 
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
